<template>
  <planificacion-anual-tabla />
</template>

<script>
// Vuex
import { mapActions } from "vuex";
import PlanificacionAnualTabla from '../../components/tablas/lineas/PlanificacionAnualTabla';



export default {
  components: { PlanificacionAnualTabla },
  methods: {
    // Acciones de Vuex
    ...mapActions(["AccionCambiar"]),

    // Función para actualizar url en state
    actualizarURL() {
      let me = this;
      me.AccionCambiar(this.$route.path);
    },
  },
  created() {
    // Ejecución de actualizarURL una vez que se carga el componente
    this.actualizarURL();
  },
};
</script>